import { FC } from 'react';

import { IHeaderTitleProps } from './types';

export const HeaderTitle: FC<IHeaderTitleProps> = ({ title, logo }) => (
  <span>
    {logo}
    {title}
  </span>
);
